import ResourceProvider from 'modules/resource-provider'
import { getCompanyById } from '../selectors'

export default ResourceProvider({
  resource: 'company',
  resourceSelector: (state, ownProps) =>
    getCompanyById(state)(ownProps.companyId),
})
